import { combineReducers } from "redux";
import Notification from "./notification/reducer";
const rootReducer = {
  Notification,
};

export default rootReducer;
